import React, { memo } from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a1400] py-16 px-4" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <div className="text-center mb-10" data-id="element-69">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-70">
            🎭 ¿Qué agrega{' '}
            <span className="text-[#FFD700]" data-id="element-71">Teatro en Escena Pro™</span>?
          </h2>
          <p className="text-gray-300 text-base max-w-2xl mx-auto" data-id="element-72">
            La función anual deja de ser una obligación y se convierte en el
            mejor momento del año.
          </p>
        </div>

        {/* Compact Comparison */}
        <div className="bg-black border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-10" data-id="element-73">
          <div className="grid grid-cols-3 bg-[#0d0a00] border-b border-[#FFD700]/30" data-id="element-74">
            <div className="p-3 font-bold text-white text-sm" data-id="element-75">Situación</div>
            <div className="p-3 font-bold text-gray-400 text-sm text-center border-l border-[#FFD700]/30" data-id="element-76">
              Sin Teatro en Escena Pro
            </div>
            <div className="p-3 font-bold text-[#FFD700] text-sm text-center border-l border-[#FFD700]/30" data-id="element-77">
              Con Teatro en Escena Pro
            </div>
          </div>
          {[['Buscás guiones desesperado en octubre', '12 obras listas para montar', '12 obras listas para montar' // Wait, the table has 2 columns in the prompt but 3 here. I will adapt situation to the first, and the rest to the next two.
        ], ['Actos patrióticos con versitos sin emoción', 'Teatro de imagen que el público recuerda', 'Teatro de imagen que el público recuerda'], ['Escenografía improvisada a las 11 PM', 'Sistema $0 que parece profesional', 'Sistema $0 que parece profesional'], ['El técnico de audio pone la canción equivocada', 'Cue-Sheet exacto para cada momento', 'Cue-Sheet exacto para cada momento'], ['La directora pide documentos y los improvisás', 'Modelos legales listos para entregar', 'Modelos legales listos para entregar']].map(([situation, without, withEco], i) => <div key={i} className="grid grid-cols-2 sm:grid-cols-3 border-b border-gray-800 last:border-b-0" data-id="element-78">
              <div className="hidden sm:block p-3 text-white text-xs sm:text-sm" data-id="element-79">
                {situation}
              </div>
              <div className="p-3 text-gray-500 text-xs sm:text-sm sm:border-l border-gray-800 bg-gray-900/30" data-id="element-80">
                {situation} {/* In mobile, show the negative situation here */}
              </div>
              <div className="p-3 text-white text-xs sm:text-sm border-l border-gray-800 bg-[#FFD700]/5" data-id="element-81">
                {withEco}
              </div>
            </div>)}
        </div>

        {/* Compact Modules List */}
        <div className="bg-black border border-[#FFD700]/20 rounded-2xl p-6" data-id="element-82">
          <h3 className="text-xl font-black text-white text-center mb-5" data-id="element-83">
            ✅ Teatro en Escena Pro™ incluye:
          </h3>
          <div className="space-y-3" data-id="element-84">
            <div className="flex items-start gap-3" data-id="element-85">
              <span className="text-lg" data-id="element-86">📗</span>
              <p className="text-sm text-white" data-id="element-87">
                <span className="font-bold" data-id="element-88">12 Guiones Listos</span>{' '}
                <span className="text-gray-400" data-id="element-89">
                  · para todos los niveles · adaptables · con ficha técnica
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-90">
              <span className="text-lg" data-id="element-91">📘</span>
              <p className="text-sm text-white" data-id="element-92">
                <span className="font-bold" data-id="element-93">5 Actos Escolares Sin Versito</span>{' '}
                <span className="text-gray-400" data-id="element-94">
                  · 25/5 · 9/7 · 24/3 · Día del Maestro
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-95">
              <span className="text-lg" data-id="element-96">📙</span>
              <p className="text-sm text-white" data-id="element-97">
                <span className="font-bold" data-id="element-98">Escenografía $0</span>{' '}
                <span className="text-gray-400" data-id="element-99">
                  · iluminación con celulares · vestuario de casa · maquillaje
                  de farmacia
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-100">
              <span className="text-lg" data-id="element-101">📕</span>
              <p className="text-sm text-white" data-id="element-102">
                <span className="font-bold" data-id="element-103">Manual del Director</span>{' '}
                <span className="text-gray-400" data-id="element-104">
                  · cronograma 8 semanas · planilla de ensayos · reparto
                  estratégico
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-105">
              <span className="text-lg" data-id="element-106">📓</span>
              <p className="text-sm text-white" data-id="element-107">
                <span className="font-bold" data-id="element-108">Sonido y Atmósfera</span>{' '}
                <span className="text-gray-400" data-id="element-109">
                  · Cue-Sheet · 20 atmósferas · fuentes gratuitas
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-110">
              <span className="text-lg" data-id="element-111">📔</span>
              <p className="text-sm text-white" data-id="element-112">
                <span className="font-bold" data-id="element-113">Kit Legal Argentina</span>{' '}
                <span className="text-gray-400" data-id="element-114">
                  · autorización de imagen · nota a dirección · marco legal de
                  música
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}